var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCommision = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.68,
    height: 18,
    viewBox: "0 0 17.68 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-303.322,342.976v.059h.02C-303.312,343.016-303.312,343-303.322,342.976Zm0,1.177v.1c.01-.04.02-.07.03-.1Z",
    transform: "translate(308.48 -341)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-298.672,343.963v5.458h-1.766v-6.386h-2.884v-.059a2.624,2.624,0,0,0-2.205-1.956c-.11-.01-.229-.02-.339-.02s-.22.01-.329.02a2.619,2.619,0,0,0-2.285,2.594,2.622,2.622,0,0,0,2.085,2.564,3.06,3.06,0,0,0,.529.05,3.07,3.07,0,0,0,.529-.05,2.614,2.614,0,0,0,2.015-1.925v-.1h1.766v5.268H-303.3a2.632,2.632,0,0,0-2.564-2.035A2.616,2.616,0,0,0-308.48,350a2.616,2.616,0,0,0,2.614,2.614,2.632,2.632,0,0,0,2.574-2.075h1.736v5.308h-1.736a3.276,3.276,0,0,1,.05.539,2.757,2.757,0,0,1-.06.569h2.864v-6.416h1.766V356h7.872V343.963Zm-7.194,1.028a1.377,1.377,0,0,1-1.367-1.377,1.377,1.377,0,0,1,1.367-1.377,1.38,1.38,0,0,1,1.377,1.377A1.38,1.38,0,0,1-305.866,344.991Zm0,6.386A1.378,1.378,0,0,1-307.233,350a1.378,1.378,0,0,1,1.367-1.377A1.38,1.38,0,0,1-304.489,350,1.38,1.38,0,0,1-305.866,351.377Zm13.949,3.5h-5.638v-9.8h5.638Z",
    transform: "translate(308.48 -341)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-303.322,355.747v.1h.03C-303.3,355.817-303.312,355.787-303.322,355.747Zm0,1.208v.069a.551.551,0,0,1,.02-.069Z",
    transform: "translate(308.48 -341)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-303.292,355.847h-.03v-.1a2.617,2.617,0,0,0-2.015-1.926,3.17,3.17,0,0,0-.529-.049,3.16,3.16,0,0,0-.529.049,2.624,2.624,0,0,0-2.085,2.565,2.619,2.619,0,0,0,2.285,2.594c.109.01.219.02.329.02s.229-.01.339-.02a2.624,2.624,0,0,0,2.205-1.956v-.069h.02a2.757,2.757,0,0,0,.06-.569A3.276,3.276,0,0,0-303.292,355.847Zm-2.574,1.916a1.377,1.377,0,0,1-1.367-1.377,1.377,1.377,0,0,1,1.367-1.377,1.38,1.38,0,0,1,1.377,1.377A1.38,1.38,0,0,1-305.866,357.763Z",
    transform: "translate(308.48 -341)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-308.48,349.5",
    transform: "translate(308.48 -341)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCommision);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/commision.719898d79cec8a9d0ffa92bf8dd09a4e.svg";